var _style, _rect, _g, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDeviceLink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:20;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -69,
    y: -50,
    className: "st0",
    width: 652,
    height: 927
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "376,22.7 464,410.3 48,453.5 59.9,288.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "295.5,30.1 376,370.1 34.6,447.6 43.5,282.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "355.3,337.7 106.9,394.1 413.8,362.2 348,72.6 301.7,111.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "287.9,78.2 235.4,130.7 279.5,304.2 93.3,383.7 93,390.1 348,332.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "87.4,264.2 222.2,102.7 272.3,299.8 81.8,381.2  "
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 256,
    cy: 256,
    r: 246
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M445.7,277.8c0,30-24.4,56.5-54.5,56.5H120.8c-30.1,0-54.4-26.5-54.4-56.5c0-29.9,24.3-55.3,54.4-55.3 c3.2,0,6.4-0.3,9.5,0.3c1.7-36.7,29.6-66.1,63.7-66.1c19.5,0,36.9,9.4,48.6,24.4c10.5-32.2,38.9-55.4,72.2-55.4 c42.3,0,76.5,37.2,76.5,83c0,4.4-0.3,8.6-0.9,12.7c0.3,0,0.6,1.1,0.9,1.1C421.3,222.5,445.7,247.9,445.7,277.8z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeviceLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/device-link.bc52acec.svg";
export { ForwardRef as ReactComponent };